import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TransRejectionPage } from './trans-rejection';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    TransRejectionPage,
  ],
  imports: [
    IonicPageModule.forChild(TransRejectionPage),
    NgxPaginationModule
  ],
})
export class TransRejectionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/trans-rejection/trans-rejection.module.ts